import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  planTitle: {
    fontWeight: 400,
    color: theme.palette.success.dark,
    fontSize: 20,
  },
  plan: {
    padding: theme.spacing(2),
    border: '1px solid',
    borderColor: theme.palette.success.dark,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  executeTitle: {
    fontWeight: 400,
    color: theme.palette.info.dark,
    fontSize: 20,
  },
  execute: {
    padding: theme.spacing(2),
    border: '1px solid',
    borderColor: theme.palette.info.dark,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  decisionTitle: {
    fontWeight: 400,
    color: theme.palette.warning.main,
    fontSize: 20,
  },
  decision: {
    padding: theme.spacing(2),
    border: '1px solid',
    borderColor: theme.palette.warning.main,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}))

export default styles
